/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Add_User_To_Group_FailedInputs */

const en_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error adding user to group. ${i?.error}`)
};

const fr_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l’ajout de l’utilisateur au groupe. ${i?.error}`)
};

const de_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Hinzufügen des Benutzers zur Gruppe. ${i?.error}`)
};

const it_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'aggiunta dell'utente al gruppo. ${i?.error}`)
};

const ru_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при добавлении пользователя в группу. ${i?.error}`)
};

const es_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al agregar usuario al grupo. ${i?.error}`)
};

const zh_cn2_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将用户添加到组时出错。${i?.error}`)
};

const ja_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザーをグループに追加中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह में उपयोगकर्ता जोड़ने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_add_user_to_group_failed = /** @type {(inputs: Team_Manager_Add_User_To_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao adicionar usuário ao grupo. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error adding user to group. {error}" |
*
* @param {Team_Manager_Add_User_To_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_user_to_group_failed = /** @type {((inputs: Team_Manager_Add_User_To_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_User_To_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_add_user_to_group_failed(inputs)
	if (locale === "de") return de_team_manager_add_user_to_group_failed(inputs)
	if (locale === "it") return it_team_manager_add_user_to_group_failed(inputs)
	if (locale === "ru") return ru_team_manager_add_user_to_group_failed(inputs)
	if (locale === "es") return es_team_manager_add_user_to_group_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_add_user_to_group_failed(inputs)
	if (locale === "ja") return ja_team_manager_add_user_to_group_failed(inputs)
	if (locale === "hi") return hi_team_manager_add_user_to_group_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_add_user_to_group_failed(inputs)
	return en_team_manager_add_user_to_group_failed(inputs)
});